// Canonical vendor business categories. Must be kept in sync with
// BUSINESS_TYPES in /app/backend/core/models.py — the backend rejects
// anything outside this list, and "Other" requires business_type_other.
export const BUSINESS_TYPES = [
  "Cafe", "Bakery & Sweets", "Retail Store", "Supermarket & Grocery",
  "Clothing & Fashion", "Footwear", "Jewellery", "Electronics & Mobiles",
  "Salon & Spa", "Pharmacy & Healthcare", "Optical & Eyewear",
  "Furniture & Home Decor", "Automobile (Showroom/Service)",
  "Hotel & Hospitality", "Gym & Fitness", "Education & Coaching",
  "Events", "Other",
];

// Lucide icon *name* per business_type — the consumer homepage grid
// maps these names to actual lucide-react imports. Kept as strings so
// the taxonomy file has zero React/lucide dependencies.
export const BUSINESS_TYPE_ICONS = {
  "Cafe": "Coffee",
  "Bakery & Sweets": "Cake",
  "Retail Store": "ShoppingBag",
  "Supermarket & Grocery": "ShoppingCart",
  "Clothing & Fashion": "Shirt",
  "Footwear": "Footprints",
  "Jewellery": "Gem",
  "Electronics & Mobiles": "Smartphone",
  "Salon & Spa": "Scissors",
  "Pharmacy & Healthcare": "Stethoscope",
  "Optical & Eyewear": "Glasses",
  "Furniture & Home Decor": "Sofa",
  "Automobile (Showroom/Service)": "Car",
  "Hotel & Hospitality": "Hotel",
  "Gym & Fitness": "Dumbbell",
  "Education & Coaching": "GraduationCap",
  "Events": "PartyPopper",
  "Other": "Store",
};

// Formatted label for anywhere business_type is displayed. When the
// vendor picked "Other" and provided a free-text specification, render
// "Other — <specification>" so admins can see the actual category.
export function formatBusinessType(vendor) {
  if (!vendor) return "";
  const bt = vendor.business_type || "";
  const other = (vendor.business_type_other || "").trim();
  if (bt === "Other" && other) return `Other — ${other}`;
  return bt;
}
